import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = window.location.hostname;

export const getUserData = createAsyncThunk('sendiioApp/user/data', async () => {

	const url = API_BASE === 'localhost' ? 'http://localhost/sendiio-api/index.php/api/user_data' : 'https://sendiio.com/ajax/form/user-data';

	const response = await axios.get(url).catch((error) => {

		console.log('Error:', error);

	});

	const data = await response.data;

	return data;

});


// for testing
export const userDataUpdated = createAsyncThunk('sendiioApp/user/userDataUpdated', async () => {

	const url = API_BASE === 'localhost' ?
		'http://localhost/sendiio-api/index.php/api/user_data_updated' :
		'https://sendiio.com/ajax/form/user-data';

	const response = await axios.get(url).catch((error) => {

		console.log('Error:', error);

	});

	const data = await response.data;

	return data;

});

const initialState = {
	loading: false,
	userData: {}, // for user object
	error: null,
	success: false, // for monitoring the registration process.
}

const userDataSlice = createSlice({
	name: 'userData',
	initialState,
	reducers: {},
	extraReducers: {
		[getUserData.pending]: (state) => {
			state.loading = true
			state.error = null
		},
		[getUserData.fulfilled]: (state, { payload }) => {
			state.loading = false
			state.userData = payload.user_data
		},
		[getUserData.rejected]: (state, { payload }) => {
			state.loading = false
			state.error = payload
		},
		[userDataUpdated.pending]: (state) => {
			state.loading = true
			state.error = null
		},
		[userDataUpdated.fulfilled]: (state, { payload }) => {
			state.loading = false
			state.userData = payload.user_data
		},
		[userDataUpdated.rejected]: (state, { payload }) => {
			state.loading = false
			state.error = payload
		},
	},
});

export default userDataSlice.reducer;